import { Text } from '@chakra-ui/react';
import React from 'react';

import Modal from './Modal';
import SelfServePayoffFormBody, { SelfServePayoffSubmitValues } from './SelfServePayoffFormBody';
import Button from './ui/buttons/Button';
import PrimaryButton from './ui/buttons/PrimaryButton';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: React.ReactNode;
  dismissLabel: string;
  lienholderName?: string | null;
  lienholderSlug?: string | null;
  retailBookValue?: number | null;
  submitting: boolean;
  onSubmit: (values: SelfServePayoffSubmitValues) => Promise<void>;
};

const SelfServePayoffModal = ({
  isOpen,
  onClose,
  title,
  description,
  dismissLabel,
  lienholderName,
  lienholderSlug,
  retailBookValue,
  submitting,
  onSubmit,
}: Props) => (
  <Modal
    title={title}
    isOpen={isOpen}
    onClose={onClose}
    size="xl"
    _content={{ maxW: '670px' }}
    _header={{ mb: 2 }}
  >
    <Text textAlign="center" mb={6}>
      {description}
    </Text>
    <SelfServePayoffFormBody
      onSubmit={onSubmit}
      lienholderName={lienholderName}
      lienholderSlug={lienholderSlug}
      retailBookValue={retailBookValue}
      submitContent={() => (
        <>
          <PrimaryButton type="submit" loading={submitting}>
            SUBMIT PAYOFF
          </PrimaryButton>
          <Button variant="link" onClick={onClose} isDisabled={submitting}>
            {dismissLabel}
          </Button>
        </>
      )}
    />
  </Modal>
);

export default SelfServePayoffModal;
